// @flow
import * as React from 'react'
import uuid from 'uuid/v4'

export type Props = {
  viewBox: string,
  className: string,
  title?: string,
  description?: string,
  inline: boolean,
  style?: Object,
  children?: React.Node,
}

export default class SVGIcon extends React.Component<Props> {
  static defaultProps = {
    className: 'SVGIcon',
    inline: false,
  }

  render = () => {
    const { title, description } = this.props
    const id = `id${uuid()}`
    const titleId = title ? `t${id}` : ''
    const descriptionId = description ? `d${id}` : ''
    const labeledBy = `${titleId} ${descriptionId}`

    return (
      <svg
        className={this.className}
        style={this.props.style}
        viewBox={this.props.viewBox}
        aria-labelledby={labeledBy}
        xmlns="http://www.w3.org/2000/svg"
      >
        {title ? renderTitle(title, titleId) : null}
        {description ? renderDescription(description, descriptionId) : null}
        {this.props.children}
      </svg>
    )
  }

  get className(): string {
    return [this.props.className, this.props.inline ? `${this.props.className}--inline` : ''].join(
      ' ',
    )
  }
}

function renderTitle(title, titleId) {
  return <title id={titleId}>{title}</title>
}

function renderDescription(description, descriptionId) {
  return <desc id={descriptionId}>{description}</desc>
}
